import { filtersConfigStore } from "@stores/filtersConfigStores.js"
import { get } from "svelte/store"

const { getFilterByCurrentView } = filtersConfigStore;

function arraysEqual(a, b) {
  if (!Array.isArray(a) || !Array.isArray(b)) return false;
  if (a.length !== b.length) return false;
  const sortedA = [...a].sort();
  const sortedB = [...b].sort();
  return sortedA.every((value, index) => value === sortedB[index]);
}

export function getApplicableFilters(filters) {
  const {
    views,
    filterDefinitions,
    filterColumnDefinitions,
    filterAllowedOperators,
    filterOperators,
    currentView,
    storeLoaded,
    tab
  } = get(filtersConfigStore);

  if (!storeLoaded || !filters) return [];
  const filtersByView =  getFilterByCurrentView(
    views,
    filterDefinitions,
    filterColumnDefinitions,
    filterAllowedOperators,
    filterOperators,
    currentView,
    tab
  );
  const filtersView = filtersByView

  return filters.filter((filter) => {
    const filterTab = filtersView.filter(
      (filterView) =>
        filterView.type === filter.type && filterView.title === filter.title
    );

    if (filterTab.length === 0) return false;

    return filterTab.some((filterView) => {
      if (filterView.filterDetails.length === 0) return true;

      return filterView.filterDetails.some((filterDetail) => {
        const colMatch =
          filterDetail.column === filter.col ||
          filterDetail.columns === filter.col ||
          (Array.isArray(filterDetail.columns) &&
            Array.isArray(filter.col) &&
            arraysEqual(filter.col, filterDetail.columns));

        const datatypeMatch =
          !filterDetail.datatype ||
          (Array.isArray(filterDetail.datatype)
            ? filterDetail.datatype.includes(filter.datatype)
            : filterDetail.datatype === filter.datatype);

        return colMatch && datatypeMatch;
      });
    });
  });
}

